import { useEffect, useState } from 'react'

import { Alert, Avatar } from '@mui/material'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const EmployeeRow = ({ employee }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5 }}>
    <Avatar
      src={`/assets/images/${employee.imagen}`}
      sx={{
        transition: '.3s',
        backgroundColor: 'secondary.main',
        width: 32,
        height: 32,
        color: 'secondary.contrastText',
        flexShrink: 0,
      }}
    />
    <Typography variant="body2">
      {[employee.nombre, employee.primer_apellido, employee.segundo_apellido]
        .filter(Boolean)
        .join(' ')}
    </Typography>
  </Box>
)

EmployeeRow.propTypes = {
  employee: PropTypes.object.isRequired,
}

const NivelCard = ({ nivel, variant = 'default' }) => {
  const colors = {
    superior: 'grey.100',
    usuario: 'success.light',
    subordinado: 'grey.100',
    default: 'background.paper',
  }

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        backgroundColor: colors[variant],
      }}
    >
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
        {nivel.descripcion}
      </Typography>
      {nivel.empleados && nivel.empleados.length > 0 ? (
        nivel.empleados.map((emp, i) => <EmployeeRow key={i} employee={emp} />)
      ) : (
        <Typography variant="body2" color="text.secondary">
          Sin empleados asignados
        </Typography>
      )}
    </Box>
  )
}

NivelCard.propTypes = {
  nivel: PropTypes.object.isRequired,
  variant: PropTypes.string,
}

const OrganigramaReducido = ({ response }) => {
  const [organigrama, setOrganigrama] = useState(response)

  useEffect(() => {
    setOrganigrama(response)
  }, [response])

  if (!organigrama || organigrama.length === 0) {
    return (
      <Alert severity="warning">
        No hemos podido obtener el organigrama para este usuario. Puede que se encuentre mal
        parametrizado
      </Alert>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {organigrama.map((nivelSuperior, i) => (
        <Box key={i}>
          <NivelCard nivel={nivelSuperior} variant="superior" />

          {nivelSuperior.hijos && nivelSuperior.hijos.length > 0 && (
            <Box sx={{ ml: 4, mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {nivelSuperior.hijos.map((nivelUsuario, j) => (
                <Box key={j}>
                  <NivelCard nivel={nivelUsuario} variant="usuario" />

                  {nivelUsuario.hijos && nivelUsuario.hijos.length > 0 && (
                    <>
                      <Divider sx={{ my: 1.5, ml: 4 }} />
                      <Box
                        sx={{
                          ml: 4,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1.5,
                        }}
                      >
                        {nivelUsuario.hijos.map((nivelHijo, k) => (
                          <NivelCard key={k} nivel={nivelHijo} variant="subordinado" />
                        ))}
                      </Box>
                    </>
                  )}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  )
}

OrganigramaReducido.propTypes = {
  response: PropTypes.array,
}

export default OrganigramaReducido
